import { Bars3Icon } from "@heroicons/react/24/outline";
import { ReactSortable } from "react-sortablejs";
import { SORTABLE_OPTIONS } from "../constants";
import { getProgramId } from "../utils";
import StatusToggle from "./StatusToggle";

export default function ProgramsTable({
  programs,
  isLoading,
  error,
  isSavingOrder,
  togglingIds,
  onSetList,
  onReorderEnd,
  onToggleStatus,
  onOpenEvents,
  onEdit,
}) {
  if (isLoading || error || programs.length === 0) {
    return (
      <tbody className="divide-y divide-gray-100 bg-white">
        {isLoading ? (
          <tr>
            <td className="px-6 py-6 text-sm text-gray-500" colSpan={4}>
              Loading programs...
            </td>
          </tr>
        ) : null}
        {!isLoading && error ? (
          <tr>
            <td className="px-6 py-6 text-sm text-red-600" colSpan={4}>
              {error}
            </td>
          </tr>
        ) : null}
        {!isLoading && !error && programs.length === 0 ? (
          <tr>
            <td className="px-6 py-6 text-sm text-gray-500" colSpan={4}>
              No loyalty programs found.
            </td>
          </tr>
        ) : null}
      </tbody>
    );
  }

  return (
    <ReactSortable
      tag="tbody"
      list={programs}
      setList={onSetList}
      onEnd={onReorderEnd}
      {...SORTABLE_OPTIONS}
      className="divide-y divide-gray-100 bg-white"
    >
      {programs.map((program, index) => {
        const programId = getProgramId(program);
        const isToggling = togglingIds.includes(programId);
        return (
          <tr key={programId || index} className="text-sm text-gray-700">
            <td className="px-6 py-4 font-semibold text-gray-900">
              <div className="flex items-center gap-2">
                <span
                  className="drag-handle inline-flex cursor-grab text-gray-400 hover:text-gray-600 active:cursor-grabbing"
                  aria-label="Drag to reorder program"
                >
                  <Bars3Icon className="h-5 w-5" />
                </span>
                {/* {index + 1} */}
              </div>
            </td>
            <td className="px-6 py-4 font-semibold text-gray-900">{program.title_en || "—"}</td>
            <td className="px-6 py-4">
              <StatusToggle
                programTitle={program.title_en}
                status={program.status}
                disabled={!programId || isToggling || isSavingOrder}
                isUpdating={isToggling}
                onToggle={() => onToggleStatus(program)}
              />
            </td>
            <td className="px-6 py-4">
              {programId ? (
                <div className="flex items-center gap-4">
                  <button
                    type="button"
                    className="text-sm font-semibold text-cyan-600 hover:text-cyan-700"
                    onClick={() => onOpenEvents(program)}
                  >
                    Events
                  </button>
                  <button
                    type="button"
                    className="text-sm font-semibold text-cyan-600 hover:text-cyan-700"
                    onClick={() => onEdit(programId)}
                  >
                    Edit
                  </button>
                </div>
              ) : (
                "—"
              )}
            </td>
          </tr>
        );
      })}
    </ReactSortable>
  );
}
